export enum LocalStorageKey {
  UI_LANGUAGE = 'ui-language',
  ACTIVE_ORGANIZATION_ID = 'active-organization-id',
}
